<template>
  <q-btn
    v-bind="attrs"
    :test-id="testId"
    no-caps
    unelevated
    :padding="padding"
    @click="$emit('click', $event)"
  >
    <template #default>
      <slot />
    </template>
  </q-btn>
</template>

<script setup>
import { useAttrs } from 'vue';

defineEmits(['click']);

const attrs = useAttrs();
defineProps({
  testId: {
    type: String,
    default: 'base-button',
  },
  padding: {
    type: String,
    default: '8px 12px',
  },
});
</script>

<style>
.q-icon.on-left {
  font-size: 16px;
}
.q-icon.on-right {
  font-size: 16px;
  color: var(--icon-right-color);
}
</style>
